var map = {
	"../pages/aproval_erp/chronology/chronology.module": [
		1158,
		3
	],
	"../pages/aproval_erp/dashboard/dashboard.module": [
		1159,
		2
	],
	"../pages/aproval_erp/item-create/item-create.module": [
		1160,
		1
	],
	"../pages/aproval_erp/item-detail/item-detail.module": [
		1161,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 284;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 284
// module chunks = 4